import React from 'react';
import { Helmet } from 'react-helmet';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Student Portal',
  description:
    'NDUB Student Portal | The portal for students, faculty members and staffs',
  keywords:
    'ndub, notre dame university bangladesh, student portal, lms, ems, ndub student login',
};

export default Meta;
